export enum ModalDesign {
    UNKNOWN,
    CENTRAL,
    RIGHTALIGNEDBUTTONS,
    COMPONENT,
    LOADING
}